import styles from '../../styles';
import { translate } from '../../locales/i18n';

const PublisherMenuItems = (user) => ({
  style: styles.nav.avatarContainerPublisher,
  modeSwitchText: translate('menu_mode_consumer'),
  modeSwitchLink: '/ai-agents',
  mainMenuItems: [
    {
      text: translate('menu_my_apps'),
      link: (user && user.attributes) ? `/publisher/${user.attributes.sub}` : '/my-ai-agents',
    },
    ...(user != null ? [
      // {
      //   text: translate('menu_reviews'),
      //   link: '/reviews',
      // },
      {
        text: translate('menu_revenue'),
        link: '/publishersettings',
      },
    ] : []),
  ],
  collapsableMenuItems: [
    {
      text: translate('menu_help'),
      stateName: 'isHelpExpanded',
      items: [
        {
          text: translate('menu_faq'),
          link: '/publisherhelp',
        },
        {
          text: translate('menu_support'),
          link: '/publishersupport',
        },
      ],
    },
    {
      text: translate('menu_aionrails'),
      stateName: 'isAboutExpanded',
      items: [
        {
          text: translate('menu_project_info'),
          link: '/publisherabout',
        },
        {
          text: translate('menu_company_info'),
          link: '/publisheraboutus',
        },
        {
          text: translate('menu_careers'),
          link: '/publishercareers',
        },
        // {
        //   text: translate('menu_investors'),
        //   link: '/publisherinvestors',
        // },
        {
          text: translate('menu_legal'),
          link: '/publisherlegal',
        },
        {
          text: translate('menu_privacy'),
          link: '/publisherprivacy',
        },
        {
          text: translate('menu_contact'),
          link: '/publishercontact',
        },
      ],
    },
  ],
});

export default PublisherMenuItems;
